import { DescriptionText, H1Text, H2Text } from "../../../../design";
import React from "react";
import { AmountDivideByHundred } from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  bankImageUrl: String,
}

const Header = (props: Props) => {
  const { payment, bankImageUrl } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo}>
      <H1Text>
        FUNDING SOURCE LINK
      </H1Text>
      <H2Text>
        TRANSFER FROM
      </H2Text>
      <DescriptionText>
        {payment && payment.account && payment.account.name}
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
